'use client'

import { Button } from '@mui/material'

// Types
import type { TextButtonProps } from '@/types/components/atoms/buttons/text'

// Helpers
import { useTranslation } from '@/helpers/i18n/client'

const WhiteButtonAtom = (props: TextButtonProps) => {
	// Props
	const { lng, title, startIcon, endIcon, onClick } = props

	// Varaibles
	const { t } = useTranslation(lng)

	return (
		<Button
			variant="text"
			color="inherit"
			disableElevation
			startIcon={startIcon}
			endIcon={endIcon}
			onClick={onClick}
			sx={{
				px: 2,
				fontSize: 18,
				fontWeight: 900,
				lineHeight: 1.67,
				textTransform: 'inherit',
				color: 'common.white',
				'&:hover': { color: '#e5e5e5' }
			}}
		>
			{t(title)}
		</Button>
	)
}

export default WhiteButtonAtom
